export default function AutoComplete() {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        minHeight: '42px',
                        height: 'auto',
                        maxHeight: '40px',
                        borderRadius: '8px',
                        backgroundColor: '#ffffff',
                        padding: '0 8px !important',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        overflow: 'hidden',
                        transition: 'max-height 0.2s ease-in-out',
                        '&.Mui-focused': {
                            maxHeight: 'none',
                            flexWrap: 'wrap',
                            overflow: 'visible',
                            padding: '4px 8px !important',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderWidth: '1px',
                                borderColor: '#2b364e',
                            },
                        },
                    },
                    '& .MuiAutocomplete-input': {
                        padding: '0 !important',
                        fontSize: '14px',
                        flexGrow: 1,
                        minWidth: '50px !important',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                    },
                    '& .MuiAutocomplete-limitTags': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#2b364e',
                        marginLeft: '4px',
                        flexShrink: 0,
                        backgroundColor: '#f1f1f1',
                        height: '26px',
                        minWidth: '38px',
                        padding: '0 8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '10px',
                    },
                    '& .MuiAutocomplete-endAdornment': {
                        position: 'relative',
                        right: '0 !important',
                        top: 'unset',
                        transform: 'unset',
                        display: 'flex',
                        alignItems: 'center',
                        alignSelf: 'center',
                        '&.Mui-focused': {
                            alignSelf: 'flex-start',
                            marginTop: '8px',
                        }
                    },
                },
                tag: {
                    margin: '2px !important',
                    height: '26px',
                    backgroundColor: '#f1f1f1',
                    borderRadius: '13px',
                    maxWidth: '100px',
                    flexShrink: 0,
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#2b364e'
                    },
                    '& .MuiChip-deleteIcon': {
                        fontSize: '16px',
                        color: '#9ca3af'
                    }
                },
                paper: {
                    borderRadius: '12px',
                    marginTop: '8px',
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                    border: '1px solid #e5e7eb',
                },
                listbox: {
                    padding: '8px',
                    '& .MuiAutocomplete-option': {
                        fontSize: '14px',
                        padding: '4px 8px',
                        borderRadius: '6px',
                        '&[aria-selected="true"]': {
                            backgroundColor: '#eef2ff !important',
                        },
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: '4px',
                    marginRight: '8px',
                    color: '#d1d5db',
                    '&.Mui-checked': {
                        color: '#6366f1',
                    },
                },
            },
        },
    }
}